module.exports = __webpack_public_path__ + "img/niu20.d62d6a6b.jpg";